import { layoutDefaultColors } from '@/enum/colors'
import widgetDataTypes from '@/enum/widgetDataTypes'
import { ILayoutParametersList } from '@/types/dashboard'

export const LAYOUT_STORE_KEY = 'ActiveLayout'
export const DEFAULT_FONT_SIZE = 16
export const DEFAULT_FONT_SIZE_PX = `${DEFAULT_FONT_SIZE}px`
export const DEFAULT_FONT_COLOR = '#000000'
export const DEFAULT_REFRESH_INTERVAL_VALUE = 10
export const DEFAULT_REFRESH_DELAY_VALUE = 30
export const DEFAULT_LAYOUT_FONT_STYLE = {
    fontSize: DEFAULT_FONT_SIZE_PX,
}

export function getFilteredLayoutParameters (parameterList: Array<ILayoutParametersList>, keys: Array<string>) {
    return parameterList.reduce<Array<ILayoutParametersList>>((parameters, parameter) => {
        if (keys.includes(parameter.LayoutParameterName)) {
            parameter.Value = parameter.Value || LAYOUT_PARAMETERS_DEFAULTS[parameter.LayoutParameterName]?.Value || ''
            parameters.push(parameter)
        }

        return parameters
    }, [])
}

export const LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE = -1

export const WIDGET_CONTENT_ALIGNMENT = 'center'

export const COUNTER_CARD_LAYOUT_PREFIX = 'layout'
export const COUNTER_CARD_LAYOUT_DEFAULT_VALUE = 'default'
export const COUNTER_CARD_LAYOUT_COLUMNS_VALUE = 'three-rows'
export const COUNTER_CARD_LAYOUT_TITLE_ICON_VALUE = 'two-rows-title'
export const COUNTER_CARD_LAYOUT_TITLE_VALUE_VALUE = 'two-rows-value'
export const COUNTER_CARD_LAYOUT_DEFAULT = 'layout-default'


export const LAYOUT_PARAMETERS_DEFAULTS: Record<string, ILayoutParametersList> = {
    ColorPrimary: {
        JPath: '$.ColorPrimary',
        Value: layoutDefaultColors.primary,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 26,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorPrimary',
        LayoutParameterValueID: 612
    },
    MainBgColor: {
        JPath: '$.MainBgColor',
        Value: layoutDefaultColors.mainBgColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 46,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'MainBgColor',
        LayoutParameterValueID: 1124812
    },
    DashboardHeaderBgColor: {
        JPath: '$.DashboardHeaderBgColor',
        Value: layoutDefaultColors.dashboardHeaderBgColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 94,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'DashboardHeaderBgColor',
        LayoutParameterValueID: 1149282
    },
    SecondaryBgColor: {
        JPath: '$.SecondaryBgColor',
        Value: layoutDefaultColors.secondaryBgColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 47,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'SecondaryBgColor',
        LayoutParameterValueID: 1124788
    },
    ColorFrames: {
        JPath: '$.ColorFrames',
        Value: layoutDefaultColors.frames,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 28,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorFrames',
        LayoutParameterValueID: 614
    },
    ColorBackground: {
        JPath: '$.ColorBackground',
        Value: layoutDefaultColors.background,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 27,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorBackground',
        LayoutParameterValueID: 613
    },
    MainTextColor: {
        JPath: '$.MainTextColor',
        Value: layoutDefaultColors.mainTextColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 51,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'MainTextColor',
        LayoutParameterValueID: 1124794
    },
    FontSize: {
        JPath: '$.FontSize',
        Value: '16',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 2,
        ParameterTypeName: 'Number',
        LayoutParameterName: 'FontSize',
        LayoutParameterValueID: 604
    },
    ColorWidgetGroupTitles: {
        JPath: '$.ColorWidgetGroupTitles',
        Value: layoutDefaultColors.widgetGroupTitles,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 31,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorWidgetGroupTitles',
        LayoutParameterValueID: 617
    },
    WidgetGroupTitlesFontSize: {
        JPath: '$.WidgetGroupTitlesFontSize',
        Value: '22',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 20,
        ParameterTypeName: 'Number',
        LayoutParameterName: 'WidgetGroupTitlesFontSize',
        LayoutParameterValueID: 606
    },
    ActiveCallWarning: {
        JPath: '$.ActoveCallWarning',
        Value: '1',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 33,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'ActiveCallWarning',
        LayoutParameterValueID: 6770
    },
    ActiveCallLimit: {
        JPath: '$.ActiveCallLimit',
        Value: '1',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 34,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'ActiveCallLimit',
        LayoutParameterValueID: 6767
    },
    HoldTimeWarning: {
        JPath: '$.HoldTimeWarning',
        Value: '1',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 37,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'HoldTimeWarning',
        LayoutParameterValueID: 7350
    },
    HoldTimeLimit: {
        JPath: '$.HoldTimeLimit',
        Value: '1',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 38,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'HoldTimeLimit',
        LayoutParameterValueID: 6761
    },
    MinRefreshInterval: {
        JPath: '$.MinRefreshInterval',
        Value: '1000',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 21,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'MinRefreshInterval',
        LayoutParameterValueID: 607
    },
    RefreshRealTimeDataDelay: {
        JPath: '$.RefreshRealTimeDataDelay',
        Value: '30',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 22,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'RefreshRealTimeDataDelay',
        LayoutParameterValueID: 608
    },
    ReportInterval: {
        JPath: '$.ReportInterval',
        Value: '180',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 23,
        ParameterTypeName: 'Interval',
        LayoutParameterName: 'ReportInterval',
        LayoutParameterValueID: 609
    },
    ReportSwitching: {
        JPath: '$.ReportSwitching',
        Value: '0',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 24,
        ParameterTypeName: 'Boolean',
        LayoutParameterName: 'ReportSwitching',
        LayoutParameterValueID: 610
    },
    ReportRefresh: {
        JPath: '$.ReportRefresh',
        Value: '0',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 25,
        ParameterTypeName: 'Boolean',
        LayoutParameterName: 'ReportRefresh',
        LayoutParameterValueID: 611
    },
    ShowWidgetTitles: {
        JPath: '$.ShowWidgetTitles',
        Value: '1',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 1,
        ParameterTypeName: 'Boolean',
        LayoutParameterName: 'ShowWidgetTitles',
        LayoutParameterValueID: 603
    },
    CardsBgColor: {
        JPath: '$.CardsBgColor',
        Value: layoutDefaultColors.cardsBgColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 50,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'CardsBgColor',
        LayoutParameterValueID: 1124797
    },
    ColorWidgetHeaderText: {
        JPath: '$.ColorWidgetHeaderText',
        Value: layoutDefaultColors.colorWidgetHeaderText,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 52,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorWidgetHeaderText',
        LayoutParameterValueID: 1124791
    },
    ColorWidgetBackground: {
        JPath: '$.ColorWidgetBackground',
        Value: layoutDefaultColors.colorWidgetBackground,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 53,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorWidgetBackground',
        LayoutParameterValueID: 1124806
    },
    WidgetBorderColor: {
        JPath: '$.WidgetBorderColor',
        Value: layoutDefaultColors.colorWidgetBorder,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 65,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'WidgetBorderColor',
        LayoutParameterValueID: 1129250
    },
    ColorTableHeaderBg: {
        JPath: '$.ColorTableHeaderBg',
        Value: layoutDefaultColors.colorTableHeaderBg,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 54,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorTableHeaderBg',
        LayoutParameterValueID: 1124800
    },
    ColorTableHeaderText: {
        JPath: '$.ColorTableHeaderText',
        Value: layoutDefaultColors.colorTableHeaderText,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 96,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorTableHeaderText',
        LayoutParameterValueID: 1150212
    },
    ColorTableContentText: {
        JPath: '$.ColorTableContentText',
        Value: layoutDefaultColors.colorTableContentText,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 55,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorTableContentText',
        LayoutParameterValueID: 1124803
    },
    WidgetTableContentFontSize: {
        JPath: '$.WidgetTableContentFontSize',
        Value: '16',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 41,
        ParameterTypeName: 'Number',
        LayoutParameterName: 'WidgetTableContentFontSize',
        LayoutParameterValueID: 1120571
    },
    WidgetTitlesFontSize: {
        JPath: '$.WidgetTitlesFontSize',
        Value: '22',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 3,
        ParameterTypeName: 'Number',
        LayoutParameterName: 'WidgetTitlesFontSize',
        LayoutParameterValueID: 605
    },
    OnHoldColor: {
        JPath: '$.OnHoldColor',
        Value: layoutDefaultColors.onHold,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 45,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'OnHoldColor',
        LayoutParameterValueID: 1123388
    },
    InCallColor: {
        JPath: '$.InCallColor',
        Value: layoutDefaultColors.inCall,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 44,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'InCallColor',
        LayoutParameterValueID: 1123385
    },
    LoginStatusLimitColor: {
        JPath: '$.LoginStatusLimitColor',
        Value: layoutDefaultColors.loginStatusLimit,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 43,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'LoginStatusLimitColor',
        LayoutParameterValueID: 1122809
    },
    LoginStatusWarningColor: {
        JPath: '$.LoginStatusWarningColor',
        Value: layoutDefaultColors.loginStatusWarning,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 42,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'LoginStatusWarningColor',
        LayoutParameterValueID: 1122806
    },
    HoldTimeLimitColor: {
        JPath: '$.HoldTimeLimitColor',
        Value: layoutDefaultColors.holdTimeLimitColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 40,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'HoldTimeLimitColor',
        LayoutParameterValueID: 6773
    },
    HoldTimeWarningColor: {
        JPath: '$.HoldTimeWarningColor',
        Value: layoutDefaultColors.holdTimeWarningColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 39,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'HoldTimeWarningColor',
        LayoutParameterValueID: 6776
    },
    ActiveCallLimitColor: {
        JPath: '$.ActiveCallLimitColor',
        Value: layoutDefaultColors.activeCallLimitColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 36,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ActiveCallLimitColor',
        LayoutParameterValueID: 6779
    },
    ActiveCallWarningColor: {
        JPath: '$.ActiveCallWarningColor',
        Value: layoutDefaultColors.activeCallWarningColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 35,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ActiveCallWarningColor',
        LayoutParameterValueID: 6782
    },
    ItemsSecondaryColor: {
        JPath: '$.ItemsSecondaryColor',
        Value: layoutDefaultColors.itemsSecondaryColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 49,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ItemsSecondaryColor',
        LayoutParameterValueID: 1124809
    },
    ItemsMainColor: {
        JPath: '$.ItemsMainColor',
        Value: layoutDefaultColors.itemsMainColor,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 48,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ItemsMainColor',
        LayoutParameterValueID: 1124785
    },
    ColorWidgetGroupFrames: {
        JPath: '$.ColorWidgetGroupFrames',
        Value: layoutDefaultColors.widgetGroupFrames,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 30,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorWidgetGroupFrames',
        LayoutParameterValueID: 616
    },
    ColorWidgetGroupBackground: {
        JPath: '$.ColorWidgetGroupBackground',
        Value: layoutDefaultColors.widgetGroupBackground,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 29,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'ColorWidgetGroupBackground',
        LayoutParameterValueID: 615
    },
    // In develop database there are parameters like those two, meaning they have same ids but different names, and what happens is that when we are creating new layout we do send on back-end duplicates, it get 2 records with ID 57 (the one from config and one from db) and same story for 58. Looks like they are not used
    // SoundError: {
    //     IsText: 0,
    //     JPath: '$.SoundError',
    //     LayoutParameterID: 58,
    //     LayoutParameterName: 'SoundError',
    //     LayoutParameterValueID: 1129001,
    //     ParameterTypeName: 'SingleSoundSelector',
    //     Value: 'none',
    //     ValueText: ''
    // },
    // SoundWarning: {
    //     IsText: 0,
    //     JPath: '$.SoundWarning',
    //     LayoutParameterID: 57,
    //     LayoutParameterName: 'SoundWarning',
    //     LayoutParameterValueID: 1128998,
    //     ParameterTypeName: 'SingleSoundSelector',
    //     Value: 'none',
    //     ValueText: ''
    // },
    DashboardLogo: {
        JPath: '$.DashboardLogo',
        Value: '',
        IsText: 1,
        ValueText: '',
        LayoutParameterID: 32,
        ParameterTypeName: 'DashboardLogo',
        LayoutParameterName: 'DashboardLogo',
        LayoutParameterValueID: 86
    },
    Favicon: {
        JPath: '$.Favicon',
        Value: '',
        IsText: 1,
        ValueText: '',
        LayoutParameterID: 56,
        ParameterTypeName: 'FaviconIcon',
        LayoutParameterName: 'Favicon',
        LayoutParameterValueID: 1127275
    },
    DialingColor: {
        JPath: '$.DialingColor',
        Value: layoutDefaultColors.inDialing,
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 67,
        ParameterTypeName: 'Color',
        LayoutParameterName: 'DialingColor',
        LayoutParameterValueID: 0
    },
    DisableVisualAlertOnThreshold: {
        JPath: '$.DisableVisualAlertOnThreshold',
        Value: '0',
        IsText: 0,
        ValueText: '',
        LayoutParameterID: 92,
        ParameterTypeName: 'Boolean',
        LayoutParameterName: 'DisableVisualAlertOnThreshold',
        LayoutParameterValueID: 0
    },
    LoginStatusesConfiguration: {
        JPath: '$.LoginStatusesConfiguration',
        Value: '',
        IsText: 1,
        ValueText: '',
        LayoutParameterID: 93,
        ParameterTypeName: 'Login Statuses Settings',
        LayoutParameterName: 'LoginStatusesConfiguration',
        LayoutParameterValueID: 0
    }
}

export function ensureRequiredParameters (parameters: Array<ILayoutParametersList>) {
    const requiredParams = new Map(Object.values(LAYOUT_PARAMETERS_DEFAULTS).map(obj => [ obj.LayoutParameterName, obj ]))
    parameters.forEach(param => {
        requiredParams.set(param.LayoutParameterName, param)
    })
    return Array.from(requiredParams.values())
}

export const defaultLayout = (LayoutAccountID?: number) => ({
    LayoutID: 1,
    LayoutName: 'Default Layout',
    LayoutStatusID: 1,
    LayoutAccountID: LayoutAccountID,
    LayoutStatusName: 'Enable',
    LayoutParametersList: [ ...Object.values(LAYOUT_PARAMETERS_DEFAULTS) ]
})

export const extensionThresholdKeys = [
    'ActiveCallWarningColor',
    'ActiveCallLimitColor',
    'HoldTimeWarningColor',
    'HoldTimeLimitColor',
    'ActiveCallWarning',
    'ActiveCallLimit',
    'HoldTimeWarning',
    'HoldTimeLimit',
]

export const defaultExtensionThresholdConfig = {
    ActiveCallWarningColor: 'green',
    ActiveCallLimitColor: 'red',
    HoldTimeWarningColor: 'green',
    HoldTimeLimitColor: 'red',
    ActiveCallWarning: 1,
    ActiveCallLimit: 1,
    HoldTimeWarning: 1,
    HoldTimeLimit: 1,
}

export type TWidgetComponentSetting = {
    showWidgetHeader: boolean
    showWidgetTemplateIcon: boolean
    showWidgetTitle: boolean
    showWidgetTimeFrame: boolean
    showWidgetInfo: boolean
    showWidgetActions: boolean
    widgetHeaderType: 'default' | 'absolute' | 'sticky'
}
export const widgetComponentTypeSettingDefault: TWidgetComponentSetting = {
    showWidgetHeader: true,
    showWidgetTemplateIcon: true,
    showWidgetTitle: true,
    showWidgetTimeFrame: true,
    showWidgetInfo: false,
    showWidgetActions: true,
    widgetHeaderType: 'default'
}

export const widgetComponentTypeSettings: Record<number, TWidgetComponentSetting> = {
    [widgetDataTypes.COUNTER_TYPE_ID]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.HISTORY_COUNTERS]: {
        showWidgetHeader: false,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: false,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.QUEUE_COUNTER_TYPE_ID]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.TOTAL_OUTGOING_CALLS]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.AVERAGE_CALLS_DURATION]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.CLOCK_AND_DATE_TYPE_ID]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.AI_SUMMARY_NUMBERS_LIST]: {
        ...widgetComponentTypeSettingDefault,
        showWidgetTimeFrame: false,
    },
    [widgetDataTypes.AI_SUMMARY_BULLETS_LIST]: {
        ...widgetComponentTypeSettingDefault,
        showWidgetTimeFrame: false,
    },
    [widgetDataTypes.AI_SUMMARY_TEXT]: {
        ...widgetComponentTypeSettingDefault,
        showWidgetTimeFrame: false,
    },
    [widgetDataTypes.VOICEBOT_COUNTER_TYPE_ID]: {
        ...widgetComponentTypeSettingDefault,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        widgetHeaderType: 'absolute'
    },
    [widgetDataTypes.AI_COUNTER_TYPE_ID]: {
        showWidgetHeader: true,
        showWidgetTitle: false,
        showWidgetTemplateIcon: false,
        showWidgetTimeFrame: false,
        showWidgetInfo: false,
        showWidgetActions: true,
        widgetHeaderType: 'absolute'
    }
}

